/* HolzWurmDesign UX: Laser-Wipe-Einblendung von Produkt-/Kategoriekarten beim Scrollen.
   Respektiert prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var items = [].slice.call(document.querySelectorAll('.grid > .grid__item'));
    if (!items.length) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('hwd-in');
            obs.unobserve(en.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );
    items.forEach(function (el, i) {
      if (!el.querySelector('.card-wrapper, .card')) return; /* nur Produkt-/Kategoriekarten */
      if (el.classList.contains('scroll-trigger')) {
        /* Dawns eigene Karten-Animation abloesen -> einheitlicher Laser-Wipe */
        el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'animate--zoom-in');
        el.removeAttribute('data-cascade');
      }
      el.classList.add('hwd-reveal');
      el.style.setProperty('--hwd-i', String(i % 4));
      obs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
